"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.companyPerformanceSettingsInputSchema = void 0;
const zod_1 = require("zod");
// ---- Validation (contract §G) ----
exports.companyPerformanceSettingsInputSchema = zod_1.z
    .object({
    grossShiftMinutes: zod_1.z.number().positive("Trajanje smene mora biti veće od 0."),
    standardBreakMinutes: zod_1.z.number().nonnegative("Pauza ne sme biti negativna."),
    lowerNeutralThreshold: zod_1.z.number().nonnegative("Donja granica ne sme biti negativna."),
    aboveNormThreshold: zod_1.z.number().nonnegative("Granica iznad norme ne sme biti negativna."),
    normRecommendationLowerBound: zod_1.z.number().int().nonnegative("Donja granica ne sme biti negativna.").default(80),
    normRecommendationUpperBound: zod_1.z.number().int().nonnegative("Gornja granica ne sme biti negativna.").default(120),
    normRecommendationMinLines: zod_1.z.number().int().min(1, "Minimalan broj unosa mora biti bar 1.").default(5),
    normRecommendationMinWorkers: zod_1.z.number().int().min(1, "Minimalan broj radnika mora biti bar 1.").default(2),
    rankingMinNormedMinutes: zod_1.z.number().nonnegative("Prag uzorka ne sme biti negativan."),
    effectiveFrom: zod_1.z.string().min(1, "Unesite datum važenja."),
    // Optional (2026-09-09 Settings UX fix) — this setting never retroactively
    // affects earlier entries (see the design doc), so a mandatory reason for
    // every edit was unnecessary friction. Stored as "" when left blank —
    // same column, same NOT NULL type, no migration (the change_reason column
    // is NOT NULL at the DB layer today).
    changeReason: zod_1.z.string().trim(),
})
    .refine((v) => v.standardBreakMinutes < v.grossShiftMinutes, {
    message: "Pauza mora biti manja od trajanja smene.",
    path: ["standardBreakMinutes"],
})
    .refine((v) => v.grossShiftMinutes - v.standardBreakMinutes > 0, {
    message: "Efektivni dnevni fond mora biti veći od nule.",
    path: ["standardBreakMinutes"],
})
    .refine((v) => v.lowerNeutralThreshold <= v.aboveNormThreshold, {
    message: "Donja granica neutralne zone mora biti manja ili jednaka granici iznad norme.",
    path: ["lowerNeutralThreshold"],
})
    .refine((v) => v.normRecommendationLowerBound <= v.normRecommendationUpperBound, {
    message: "Donja granica preporuke mora biti manja ili jednaka gornjoj granici.",
    path: ["normRecommendationLowerBound"],
});
//# sourceMappingURL=company-settings.js.map